import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { IPerson } from './UserDialog';

// Components
import UserDialogDetailsView from './UserDialogDetailsView';
import UserDialogDetailsEdit, { IFormValues } from './UserDialogDetailsEdit';

// Component
interface IProps {
  mode: 'edit' | 'view';
  person: IPerson;
  onEditClick: () => void;
  onSubmit: (values: IFormValues) => void;
  onDelete: () => void;
  userRole: string;
}

function UserDialogDetails(props: IProps) {
  if (props.mode === 'view') {
    return (
      <UserDialogDetailsView
        name={`${props.person.firstName} ${props.person.lastName}`}
        email={props.person.email}
        mobile={props.person.mobile}
        onEdit={props.onEditClick}
        userRole={props.userRole}
      />
    );
  } else {
    return (
      <UserDialogDetailsEdit
        values={{
          firstName: props.person.firstName,
          lastName: props.person.lastName,
          email: props.person.email,
          mobile: props.person.mobile,
          role: props.person.role
        }}
        onSubmit={props.onSubmit}
        onDelete={props.onDelete}
      />
    );
  }
}

export default observer(UserDialogDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/UserDialogDetails.tsx